import { Box, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";

export type CellBoxProps = {
  /// Highlights the cell as carrying a pending edit.
  pending?: boolean;
  /// Makes the cell clickable (cursor + hover affordance).
  onClick?: () => void;
  sx?: SxProps<Theme>;
  children?: ReactNode;
};

const baseSx = {
  p: 0.5,
  borderRadius: 1,
  minHeight: "24px",
  display: "flex",
  alignItems: "center",
} as const;

/// The shared cell wrapper: pending-edit highlight and click affordance.
export const CellBox = ({ pending, onClick, sx, children }: CellBoxProps) => (
  <Box
    onClick={onClick}
    sx={[
      baseSx,
      {
        bgcolor: pending ? "action.selected" : "inherit",
        border: pending ? "1px dashed" : "none",
        borderColor: pending ? "primary.main" : "transparent",
      },
      onClick !== undefined && {
        cursor: "pointer",
        "&:hover": { bgcolor: "action.hover" },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
